'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StylishButton_1 = require("./StylishButton");
var Styles = require("../styles");
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hideNotif: false };
        _this.handleHide = _this.handleHide.bind(_this);
        return _this;
    }
    /**
     * Handles hiding the game notification element.
     */
    Notification.prototype.handleHide = function () {
        this.setState({ hideNotif: true });
    };
    Notification.prototype.render = function () {
        if (this.state.hideNotif) {
            return ('');
        }
        return (React.createElement("div", { id: this.props.id, style: Styles.notification },
            React.createElement("p", null, this.props.notifText),
            React.createElement(StylishButton_1.StylishButton, { id: '', styles: Styles.notificationButton, text: 'Ok', events: { onClick: this.handleHide } })));
    };
    return Notification;
}(React.Component));
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Notification.js
// module id = 49
// module chunks = 0